<script type="ts">
  import { Heading } from "@getprovi/craft-svelte";
  import { Alert } from "@getprovi/craft-svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let retailerUserAuthStatus: string;
  export let styleMode: string = "";
  export let authService: any;
</script>

<style>
</style>

<div>
  {#if retailerUserAuthStatus == "pending"}
    <div
      class="fizz-flex-row fizz-inset-squish-24 fizz-radius-xlarge fizz-stack-32"
      style="background-color: #EEF8F6"
      data-testid="retailer-user-auth-pending-plp"
    >
      <div>
        <Icon type="Containers" width="93" height="78" />
      </div>

      <div>
        <div class="craft fizz-stack-4">
          <Heading as="h3" class="" size="h3"><slot name="pending-title" /></Heading>
        </div>
        <p class:fizz-stack-16={styleMode == "list"}>
          <slot name="pending-description" />
        </p>
        {#if styleMode == "list"}
          <slot name="pending-buttons" />
        {/if}
      </div>

      {#if styleMode != "list"}
        <div class="fizz-flex-item fizz-justify-end fizz-flex-row">
          <slot name="pending-buttons" />
        </div>
      {/if}
    </div>
  {:else if retailerUserAuthStatus == "invalid"}
    <div class="craft">
      <Alert
        variant="warning"
        title={authService?.invalidTitle}
        testId="retailer-user-auth-invalid-banner"
      >
        <slot name="invalid-description" />

        <svelte:fragment slot="actions">
          <slot name="invalid-buttons" />
        </svelte:fragment>
      </Alert>
    </div>
  {/if}
</div>
